import { Component, OnInit } from '@angular/core';
import { Colors } from '../../../common/const';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment/moment';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-real-time-popup',
  templateUrl: './real-time-popup.component.html',
  styleUrls: ['./real-time-popup.component.scss']
})
export class RealTimePopupComponent implements OnInit {

  colors = Colors;
  properties: any;
  unitLength = environment.unitLength;

  constructor(
    private translateService: TranslateService
  ) { }

  ngOnInit() {
  }

  formatDate(date) {
    return moment.utc(date).local().format('DD/MM/YYYY, HH:mm');
  }

  getTranslation(key) {
    return this.translateService.instant(key);
  }

}



// WEBPACK FOOTER //
// ./src/app/real-time/real-time/real-time-popup/real-time-popup.component.ts